import { Image, Container, Row, Col } from 'react-bootstrap';
import Sidebar from './AnimatedList';
import "./Services.css";

function Cargo() {
    return (
        <>
            <Image className="fade-in responsive-img" src="https://windward.ai/wp-content/uploads/2025/05/shipping-logistics-featured-scaled.jpg" height={500} width="100%" fluid />
            <Container>
                <Row>
                    <Col md={8}>
                        <h1 className='text-center my-2 text-decoration-underline'><strong>Project Bulk and
ODC Cargo Unit</strong></h1>
                        <p style={{ fontSize: '20px' }} className='justify-text'>We have handled project cargoes for customers in the offshore, heavy industry, and construction sectors, as well as heavy lift shipments for art galleries, brewing companies, and even an underwater restaurant. In India, project cargo is always on the move to meet the needs of both the public and private industries. DELTRANS GLOBAL specializes in turnkey solutions that minimize costs and optimize resources. We have many years of experience in handling bulk and project cargoes, with established contacts with project vessels and bulk owners. We ensure strict quality throughout the project life.</p>
                    </Col>
                    <Col md={4}>
                    <Sidebar/>
                    </Col>
                </Row>
            </Container>
           
        </>
    )
}

export default Cargo